import { render, staticRenderFns } from "./TelegramChatPurchases.vue?vue&type=template&id=c59f7e9c&scoped=true"
import script from "./TelegramChatPurchases.vue?vue&type=script&lang=js"
export * from "./TelegramChatPurchases.vue?vue&type=script&lang=js"
import style0 from "./TelegramChatPurchases.vue?vue&type=style&index=0&id=c59f7e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59f7e9c",
  null
  
)

export default component.exports